<script>
// Bloco de seção reutilizável: cartão com fundo cinza claro + borda (mesmo
// padrão dos meta-items do header), rounded-sm + título (estilo do BaseTable) +
// conteúdo (slot). `icon` opcional renderiza um badge circular antes do título.
// Usado no detalhe da transcrição (Resumo / Decisões / Sentimento / etc.) e
// reaproveitável em qualquer lugar que precise do mesmo padrão de bloco.
export default {
  name: 'TranscriptSummaryCard',
  props: {
    title: { type: String, default: '' },
    icon: { type: String, default: '' },
    // Inverte o esquema cinza/branco: usado quando o card vive sobre um fundo
    // já cinza (ex.: timeline do Omnichannel), pra manter contraste.
    inverted: { type: Boolean, default: false },
  },
}
</script>

<template>
  <div
    class="transcript-summary-card rounded-sm pa-4 mb-3"
    :class="{ 'transcript-summary-card--inverted': inverted }"
  >
    <div v-if="title || icon" class="d-flex align-center mb-5">
      <span v-if="icon" class="transcript-summary-card__icon mr-2">
        <icon-svg :name="icon" size="16" color="var(--white)" />
      </span>
      <span v-if="title" class="table-new-ux-v1-title">{{ title }}</span>
    </div>
    <slot />
  </div>
</template>

<style lang="sass" scoped>
// Mesmo bloco cinza-claro + borda fina dos meta-items do header.
.transcript-summary-card
  background: #F8F9FA
  border: 1px solid #F0F1F3

  // Sobre fundo cinza, o card vira branco pra destacar.
  &--inverted
    background: var(--white)

  &__icon
    display: inline-flex
    align-items: center
    justify-content: center
    width: 28px
    height: 28px
    border-radius: 50%
    background: var(--primary)
    flex-shrink: 0
</style>
